import {Component, Input, OnInit} from '@angular/core';
import {QuestionResult} from '../../../data/models/result/question-result';
import {FormBuilder, FormGroup} from '@angular/forms';
import {QuestionResultService} from '../../../services/api/result/question-result.service';
import {QUESTION_RESULT_VALIDATORS} from '../../../../constants/validators';
import {QUESTION_TYPES} from '../../../../constants/questionTypes';

@Component({
  selector: 'app-question-result-check',
  templateUrl: './question-result-check.component.html',
  styleUrls: ['./question-result-check.component.css']
})
export class QuestionResultCheckComponent implements OnInit {

  @Input() readonly = false;
  @Input() editMode = false;
  @Input() testResultId!: number;
  @Input() questionResult!: QuestionResult;
  @Input() testType!: string;

  public form!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private questionResultService: QuestionResultService,
  ) {
  }

  ngOnInit(): void {
    let isCorrect = this.questionResult.isCorrect;
    if (isCorrect === null) {
      isCorrect = this.computeIsCorrect();
    }
    this.form = this.fb.group({
      isCorrect: [isCorrect, QUESTION_RESULT_VALIDATORS.IS_CORRECT],
      comment: [this.questionResult.comment]
    });
  }

  onSubmit(event: MouseEvent): void {
    event.preventDefault();
    if (this.form.valid) {
      this.questionResultService.updateQuestionResult(this.testResultId, this.questionResult.question.id, {
        isCorrect: this.form.controls.isCorrect.value,
        comment: this.form.controls.comment.value,
      })
        .then(questionResult => {
          this.questionResult = questionResult;
          this.setEditMode(false);
        });
    }
  }

  onCancel(event: MouseEvent): void {
    event.preventDefault();
    this.form.controls.isCorrect.setValue(this.questionResult.isCorrect);
    this.form.controls.comment.setValue(this.questionResult.comment);
    this.setEditMode(false);
  }

  setEditMode(editMode: boolean): void {
    this.editMode = editMode;
  }

  computeIsCorrect(): boolean | null {
    switch (this.questionResult.question.type.techId) {
      case QUESTION_TYPES.SINGLE_ANSWER:
      case QUESTION_TYPES.MULTIPLE_ANSWER:
        for (const answerOption of this.questionResult.question.options) {
          const selected = Boolean(this.questionResult.answeredOptions) &&
            this.questionResult.answeredOptions.findIndex(o => o.optionId === answerOption.id) >= 0;
          if (answerOption.isCorrect !== selected) {
            return false;
          }
        }
        return true;
      case QUESTION_TYPES.TEXT_ANSWER:
        if (this.questionResult.answeredText.text.trim().length === 0) {
          return false;
        }
        return null;
    }
    return null;
  }

}
